import { Paper, Typography } from "@mui/material";
import styled, { css } from "styled-components";

interface Wrapper {
    $marginVariant?: "default" | "table";
}
export const Wrapper = styled(Paper)<Wrapper>`
    && {
        @media (min-width: ${({ theme }) => theme.breakpoints.values.lg}px) {
            padding: ${({ theme }) => theme.spacing(6)};
        }

        ${({ $marginVariant = "default" }) =>
            $marginVariant === "default" &&
            css`
                .MuiFormControl-root {
                    margin-bottom: 15px;
                }
            `}
    }
`;

interface Headline {
    $titleStyle?: "default" | "dashboard";
}

export const Headline = styled(Typography)<Headline>`
    && {
        ${({ $titleStyle = "default" }) =>
            $titleStyle === "dashboard" &&
            css`
                text-transform: uppercase;
                letter-spacing: 5px;
                font-weight: 700;
                line-height: 20px;
                font-size: 14px;
            `}
    }
`;

export const HeadlineWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: ${({ theme }) => theme.spacing(6)};
`;
